module.exports = __webpack_public_path__ + "media/stop_bet.9329ecff.mp3";